import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  IconButton,
  Theme,
  Tooltip,
  Typography,
  createStyles,
  makeStyles
} from '@material-ui/core';
import { ClearRounded } from '@material-ui/icons';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    dialogTitle: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: theme.spacing(2, 2, 2, 3)
    },
    title: {
      lineHeight: '120%'
    }
  })
);

interface ConfirmDialogProps {
  open: boolean;
  title: string;
  description?: string;
  onClose: () => void;
  onConfirm: () => void;
  children?: ReactNode;
}

export default function ConfirmDialog({
  open,
  title,
  description,
  onClose,
  onConfirm,
  children
}: ConfirmDialogProps) {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Dialog fullWidth maxWidth="sm" open={open} onClose={onClose}>
      <div className={classes.dialogTitle}>
        <Typography className={classes.title} variant="h6">
          {title}
        </Typography>
        <Tooltip title={t('confirmDialog.close') as string}>
          <IconButton size="small" onClick={onClose}>
            <ClearRounded />
          </IconButton>
        </Tooltip>
      </div>
      <DialogContent>
        {description && (
          <DialogContentText id="description" color="textPrimary">
            {description}
          </DialogContentText>
        )}
        {children}
      </DialogContent>
      <DialogActions>
        <Button
          fullWidth
          color="primary"
          variant="contained"
          onClick={onConfirm}
        >
          {t('confirmDialog.ok')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
